import React, { FunctionComponent } from 'react';

export interface ArrowIconProps {
  width?: string;
  height?: string;
}

const ArrowIcon: FunctionComponent<ArrowIconProps> = (props): JSX.Element => {
  /* istanbul ignore next */
  return (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.2041 6.33105C7.2041 6.20801 7.18132 6.09408 7.13574 5.98926C7.09017 5.88444 7.01725 5.78418 6.91699 5.68848L1.91309 0.793945C1.75814 0.638997 1.56901 0.561523 1.3457 0.561523C1.19076 0.561523 1.04948 0.597982 0.921875 0.670898C0.798828 0.739258 0.700846 0.834961 0.62793 0.958008C0.555013 1.08105 0.518555 1.22005 0.518555 1.375C0.518555 1.59831 0.602865 1.79655 0.771484 1.96973L5.24902 6.33105L0.771484 10.6924C0.602865 10.8656 0.518555 11.0638 0.518555 11.2871C0.518555 11.4375 0.555013 11.5742 0.62793 11.6973C0.700846 11.8249 0.798828 11.9251 0.921875 11.998C1.04948 12.071 1.19076 12.1074 1.3457 12.1074C1.56901 12.1074 1.75814 12.0299 1.91309 11.875L6.91699 6.97363C7.02181 6.87793 7.09473 6.77767 7.13574 6.67285C7.18132 6.56803 7.2041 6.4541 7.2041 6.33105Z"
        fill="#0075C9"
      />
    </svg>
  );
};

export default ArrowIcon;
